import { Request } from 'crono-fe-common/types/request';
import { DynamicsSettings } from 'crono-fe-common/types/dynamicsSettings';
import client from 'utils/clients/client';
import { ENDPOINTS } from 'config/endpoints';

export type DynamicsVerifyIntegrationResult = {
  data: { isSuccess: boolean; data?: DynamicsSettings | null };
};

class DynamicsService {
  private _alreadyRunningVerifyDynamicsIntegrationCall: Promise<DynamicsVerifyIntegrationResult> | null =
    null;

  public async verifyDynamicsIntegration(): Promise<DynamicsVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyDynamicsIntegrationCall) {
      return await this._alreadyRunningVerifyDynamicsIntegrationCall;
    } else {
      this._alreadyRunningVerifyDynamicsIntegrationCall =
        this._verifyDynamicsIntegration();
      try {
        const verifyResult =
          await this._alreadyRunningVerifyDynamicsIntegrationCall;
        return verifyResult;
      } catch {
        return {
          data: {
            isSuccess: false,
          },
        };
      } finally {
        this._alreadyRunningVerifyDynamicsIntegrationCall = null;
      }
    }
  }

  private async _verifyDynamicsIntegration(): Promise<DynamicsVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.dynamics.verify,
      config: {
        method: 'get',
      },
    };

    const result = await client(request);
    return result as DynamicsVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new DynamicsService();
